<template>
  <span
    class="icon"
    :class="[ 'icon--' + type, size && 'icon--' + size, isFixed && 'icon--fw']"
    aria-hidden="true"
    v-html="icon(type)"
  />
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: null,
        required: true
      },
      size: {
        type: String,
        default: null
      },
      isFixed: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      icon(type) {
        return require(`../../assets/icons/${type}.svg`);
	  }
	}
}
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.icon {
		display: inline-block;
		svg {
			fill: currentColor;
			height: 1em;
			width: auto;
		}
		&--fw {
			text-align: center;
			width: 1.5em;
		}
		&--lg {
			svg {
				height: 1.25em;
			}
		}
		&--xl {
			svg {
				height: 3em;
			}
		}
		&--sm {
			svg {
				height: .75em;
			}
		}
	}
</style>
